import { AxiosClient } from '@/app/shared/services';

const state = {
    offers: {
        data: [],
        isLoading: false,
        isSuccess: false,
    },
    cs_offers: {
        data: [],
        isLoading: false,
        isSuccess: false,
    },
};

const getters = {
    CLIENT_OFFERS_IS_LOADING: state => state.offers.isLoading,
    CS_OFFERS_LOADING: state => state.cs_offers.isLoading,
    CLIENT_OFFERS_LOADING_SUCCESS: state => state.offers.isSuccess,
    CLIENT_OFFERS: state => state.offers.data,
    CS_OFFERS: state => state.cs_offers.data,
    CALCULATE_PRICE_TOP: state => (sum, days, is_email_confirm, source) => {
        if (is_email_confirm || (source != '' && source != null)) {
            return state.offers.data.filter(offer => offer.sum >= sum && offer.days >= days);
        }
        return state.offers.data.slice(0, 3).filter(offer => offer.sum >= sum && offer.days >= days);
    },
    CALCULATE_PRICE_DOWN: state => (is_email_confirm, source) => {
        if (!(is_email_confirm || (source != '' && source != null))) {
            return state.offers.data.slice(3, state.offers.data.length);
        }
    },
    MIN_DAYS: state => Math.min(...state.offers.data.map(offer => offer.days)),
    MAX_DAYS: state => Math.max(...state.offers.data.map(offer => offer.days)),
    MIN_SUM: state => Math.min(...state.offers.data.map(offer => offer.sum)),
    MAX_SUM: state => Math.max(...state.offers.data.map(offer => offer.sum)),
};

const mutations = {
    SET_CLIENT_OFFERS: (state, offers) => {
        state.offers.data = offers;
    },
    SET_CLIENT_OFFERS_LOADING: (state, isLoading) => {
        state.offers.isLoading = isLoading;
    },
    SET_CS_OFFERS: (state, offers) => {
        state.cs_offers.data = offers;
    },
    SET_CS_OFFERS_LOADING: (state, isLoading) => {
        state.cs_offers.isLoading = isLoading;
    },
    SET_CLIENT_OFFERS_LOADING_SUCCESS: (state, isSuccess) => {
        state.offers.isSuccess = isSuccess;
    },
};

const actions = {
    GET_CLIENT_OFFERS: (context) => {
        context.commit('SET_CLIENT_OFFERS_LOADING', true);
        return new Promise((resolve, reject) => {
            AxiosClient.get('/offers/get')
                .then((data) => {
                    context.commit('SET_CLIENT_OFFERS', data.data);
                    context.commit('SET_CLIENT_OFFERS_LOADING_SUCCESS', true);
                    resolve();
                })
                .catch(() => {
                    reject();
                })
                .finally(() => {
                    context.commit('SET_CLIENT_OFFERS_LOADING', false);
                });
        });
    },

    GET_CS_OFFERS: context => {
        context.commit('SET_CS_OFFERS_LOADING', true);
        return new Promise((resolve, reject) => {
            AxiosClient.get('/offers/credit-score-offers')
                .then((data) => {
                    context.commit('SET_CS_OFFERS', data.data);
                    resolve();
                })
                .catch(() => {
                    reject();
                })
                .finally(() => {
                    context.commit('SET_CS_OFFERS_LOADING', false);
                });
        });
    },

    CHOSE_OFFER: (context, chosen_offer) => {
        context.commit('SET_CLIENT_OFFERS_LOADING', true);
        return new Promise((resolve, reject) => {
            AxiosClient.post('/offers/chose_offer', chosen_offer)
                .then(() => {
                    resolve();
                })
                .catch(() => {
                    reject();
                })
                .finally(() => {
                    context.commit('SET_CLIENT_OFFERS_LOADING', false);
                });
        });
    },

    SEND_SHOWCASE_VIEWS: (context, params) => {
        let base_url = process.env.NODE_ENV == 'development'
            ? process.env.VUE_APP_BASE_URL
            : `${location.origin}/api`;
        navigator.sendBeacon(base_url + '/offers/write_showcase_views', JSON.stringify(params));
    },
}

export default {
    state,
    getters,
    mutations,
    actions,
};
